/*global Flybits, Flightkit, document*/
import { html, css, LitElement } from 'lit';

/**
 * @class FlybitsError
 * @classdesc A default error UI for FlybitsSlot components.
 * @memberof Flightkit
 * @extends external:LitElement
 * @example 
 * <!-- declarative approach -->
 * <flybits-slot ref-id="homepage">
 *   <flybits-error slot="error"></flybits-error>
 * </flybits-slot>
 */
export default  class FlybitsError extends LitElement {

  static properties = {
  };
  
  static styles = css`
    :host {
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      align-content: center;
      background-color: rgba(255,255,255,0.8);
    }
    .inner-wrap{
      text-align: center;
    }
    .msg{
      display: block;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .reload-trigger{
      display: inline-block;
      font-size: 14px;
      border-radius: 20px;
      min-width: 100px;
      background-color: #3258E9;
      color: white;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      user-select: none;
    }
    .reload-trigger:hover{
      background-color: #0c94f2;
    }
  `

  constructor() {
    super();
  }
  
  connectedCallback() {
    super.connectedCallback()
  }
  
  disconnectedCallback() {
    super.disconnectedCallback()
  }

  emitReload() {
    this.dispatchEvent(new CustomEvent('reload', {
      bubbles: true
    }))
  }

  render() {
    return html`
      <div class="inner-wrap">
        <div class="msg">Sorry, something went wrong.</div>
        <div class="reload-trigger" @click="${this.emitReload}">Try again</div>
      </div>
    `
  }
}
customElements.define('flybits-error', FlybitsError);